<template>
	<div class="integral-goods-details-container">
		<div class="backBox" @click="handleClose">
			<img class="backIcon" src="../assets/Personal/iconI.png" />
			返回
		</div>
		<div class="integral-goods-details">
			<div class="image-gallery">
				<div class="thumbnails-box" v-if="goods.type == 1">
					<button class="prev-btn" @click="prevImage">
						<img src="../assets/Markets/iconA.png">
					</button>
					<div class="thumbnails-container" ref="thumbnailContainer">
						<div class="thumbnails">
							<div class="thumbnail" v-for="(image, index) in images" :key="index"
								:class="{ active: image.id === selectedImage.id }" @click="selectImage(image)">
								<img :src="image.img" alt="Thumbnail" />
								<img class="videoPlayIcon" src="../assets/MyOrder/iconK.png"
									v-if="image.type == 'video'" />
							</div>
						</div>
					</div>
					<button class="next-btn" @click="nextImage">
						<img src="../assets/Markets/iconB.png">
					</button>
				</div>
				<div class="main-image">
					<img :src="selectedImage.img" v-show="selectedImage.type == 'img'" />
					<video ref="myVideo" controls style="width: 3.9rem;height: 3.9rem;" :poster="selectedImage.img"
						:src="selectedImage.url" v-show="selectedImage.type == 'video'"></video>
				</div>
			</div>
			<div class="integral-goods">
				<div class="title">{{details.title ? details.title : ''}}</div>
				<div class="price">{{details.price ? details.price : '0'}}积分</div>
				<div class="specs" v-if="goods.type == 2">
					<span class="infoTitle">类型：</span>{{details.type ? (details.type  == 1 ? '满减券' : '折扣券') : ''}}
				</div>
				<div class="specs" v-if="goods.type == 2 && details.type  == 1">
					<span class="infoTitle">
						使用限制：
					</span>满{{details.max_price ? details.max_price : '0'}}减{{details.original_price ? details.original_price : '0'}}
				</div>
				<div class="specs" v-if="goods.type == 2 && details.type  == 2">
					<span class="infoTitle">
						使用限制：
					</span>满{{details.max_price ? details.max_price : '0'}}可用
				</div>
				<div class="specs" v-if="goods.type == 2">
					<span class="infoTitle">
						有效期：
					</span>{{details.day ? details.day : '0'}}天
				</div>
				<div class="specs" v-if="goods.type == 2 && details.type == 1">
					<span class="infoTitle">
						金额：
					</span>{{details.original_price ? details.original_price : '0'}}元
				</div>
				<div class="specs" v-if="goods.type == 2 && details.type == 2">
					<span class="infoTitle">
						折扣：
					</span>{{details.original_price ? details.original_price : '0'}}折
				</div>
				<div class="specs" v-if="goods.type == 1">
					<span class="infoTitle">
						规格：
					</span>
					{{details.specs ? details.specs : ''}}
				</div>
				<div class="inventory"><span class="infoTitle">库存：</span>{{details.stock ? details.stock : '0'}}</div>
				<div class="buyCount"><span class="infoTitle">兑换量：</span>{{details.buy_count ? details.buy_count : '0'}}
				</div>
				<div class="exchange" @click="$emit('exchange',{...details,cat_type: goods.type})">立即兑换</div>
			</div>
		</div>
		<div class="detail">
			<div class="subTilte">
				活动详情
			</div>
			<div class="rihText" v-html="details.details">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			goods: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			goods: {
				handler(newValue) {
					console.log(newValue)
					this.goodsDetails()
				},
				deep: true
			}
		},
		data() {
			return {
				details: {},
				images: [],
				selectedImage: {},
			}
		},
		methods: {
			selectImage(image) {
				this.selectedImage = image; // 点击缩略图时，更新主图像
				this.scrollToImage(image); // 点击缩略图时自动滚动
			},
			prevImage() {
				const currentIndex = this.images.findIndex(item => item.id == this.selectedImage.id);
				console.log(currentIndex, this.images, this.selectedImage.id)
				const prevIndex = (currentIndex - 1 + this.images.length) % this.images.length;
				this.selectedImage = this.images[prevIndex]; // 切换到上一张图片
				this.scrollToImage(this.selectedImage); // 切换图片时自动滚动
			},
			nextImage() {
				const currentIndex = this.images.findIndex(item => item.id == this.selectedImage.id);
				const nextIndex = (currentIndex + 1) % this.images.length;
				this.selectedImage = this.images[nextIndex]; // 切换到下一张图片
				this.scrollToImage(this.selectedImage); // 切换图片时自动滚动
			},
			scrollToImage(image) {
				this.$refs.myVideo.pause();
				const container = this.$refs.thumbnailContainer;
				const currentIndex = this.images.findIndex(item => item.id == image.id);
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailHeight = 1.14 * rootFontSize; // 每个缩略图的高度，包括间隔
				const maxVisibleThumbnails = 4; // 显示的最大缩略图数量

				// 计算当前选中缩略图的偏移量
				const thumbnailOffset = currentIndex * thumbnailHeight;

				// 计算需要滚动的距离，保持最多显示4个缩略图
				if (thumbnailOffset >= container.scrollTop + maxVisibleThumbnails * thumbnailHeight) {
					container.scrollTop = thumbnailOffset - maxVisibleThumbnails * thumbnailHeight + thumbnailHeight;
				} else if (thumbnailOffset < container.scrollTop) {
					container.scrollTop = thumbnailOffset;
				}
			},
			handleClose() {
				this.$emit('close')
			},
			goodsDetails() {
				this.$api.post('/Goods/other_goods_details', {
					goods_id: this.goods.id,
					cat_type: this.goods.type
				}).then(res => {
					if (res.code == 1) {
						this.details = res.data

						if (this.details.video) {
							this.images.push({
								id: 1,
								img: this.details.img,
								url: this.details.video,
								type: 'video'
							})
						}

						if (this.goods.type == 1) {
							this.details.banner.forEach(item => {
								this.images.push({
									id: this.images.length + 1,
									img: item,
									url: item,
									type: 'img'
								})
							})
						} else {
							this.images.push({
								id: 1,
								img: this.details.img,
								url: this.details.img,
								type: 'img'
							})
						}

						this.selectedImage = this.images.length ? this.images[0] : {
							id: ''
						}
						this.details.details = this.formatRichText(this.details.details)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					match = match.replace(/style=""/gi, '').replace(/style=''/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match) {
					match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi,
						'width:100%;');
					return match;
				});
				newContent = newContent.replace(/<img/gi,
					'<img style="width:100%;height:auto;display:block;margin:10px 0;"');

				return newContent;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.integral-goods-details-container {
		width: 100%;
		background: #FFFFFF;
		padding: .24rem .4rem;
	}

	.backBox {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
		cursor: pointer;

		.backIcon {
			width: .06rem;
			height: .1rem;
			margin-right: .06rem;
		}
	}

	.integral-goods-details {
		margin-top: .32rem;
		display: flex;
		align-items: center;

		.integral-goods {
			margin-left: .32rem;
			display: flex;
			flex-direction: column;

			.title {
				font-weight: 700;
				font-size: .28rem;
				color: #000000;
			}

			.price {
				font-weight: 700;
				font-size: .24rem;
				color: #FF0000;
			}

			.specs,
			.inventory,
			.buyCount {
				font-weight: 400;
				font-size: .16rem;
				color: #666666;
			}

			.exchange {
				margin-top: .68rem;
				width: 2.6rem;
				height: .52rem;
				background: #E29358;
				border-radius: .06rem;
				font-weight: 500;
				font-size: .15rem;
				color: #252525;
				line-height: .52rem;
				text-align: center;
				cursor: pointer;
			}

			.infoTitle {
				display: inline-block;
				width: .8rem;
			}
		}
	}

	.detail {
		margin: .32rem auto .9rem;
		width: 8.75rem;

		.subTilte {
			margin: 0 0 .2rem;
			font-weight: 500;
			font-size: .18rem;
			color: #000000;
			line-height: .26rem;
		}
	}
</style>
<style scoped>
	.image-gallery {
		display: flex;
		align-items: center;
	}

	.thumbnails-box {
		height: 3.9rem;
		margin-right: .16rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	.main-image {
		display: flex;
		align-items: center;
		position: relative;
	}

	.main-image img {
		width: 3.9rem;
		height: 3.9rem;
		object-fit: cover;
		border-radius: .1rem;
	}

	.prev-btn,
	.next-btn {
		position: absolute;
		width: .4rem;
		height: .12rem;
		padding: 0 0;

		img {
			width: .4rem;
			height: .12rem;
		}
	}

	.prev-btn {
		top: 0;
	}

	.next-btn {
		bottom: 0;
	}

	.thumbnails-container {
		height: 3.6rem;
		overflow-y: auto;
		margin-top: .20rem;
	}

	.thumbnails-container::-webkit-scrollbar {
		display: none;
	}

	.thumbnails-container {
		scrollbar-width: none;
	}

	.thumbnails {
		display: flex;
		flex-direction: column;
	}

	.thumbnail {
		cursor: pointer;
		width: .8rem;
		height: .8rem;
		margin-bottom: .1rem;
		position: relative;
	}

	.videoPlayIcon {
		position: absolute;
		top: .2rem;
		left: .2rem;
		width: .4rem !important;
		height: .4rem !important;
		border: none !important;
	}

	.thumbnail img {
		width: .8rem;
		height: .8rem;
		object-fit: cover;
		border-radius: .08rem;
		/* transition: transform 0.3s; */
	}

	/* .thumbnail:hover img {
		transform: scale(1.1);
	} */

	.thumbnail.active img {
		border: .02rem solid #f39c12;
		/* 激活状态的缩略图边框 */
	}
</style>